import * as React from 'react'
import dynamic from 'next/dynamic'

import {Card, CardItem, CardSelect} from '@components/Card'
import {
  IconCheckProduct,
  IconMaintenance,
  IconSafety,
  IconCollect,
  IconAnalyse,
  IconLogistic,
} from '@components/Icon'

const MainLayout = dynamic(() => import('@components/MainLayout'))
const Meta = dynamic(() => import('@components/Meta'))

const industryDataset = {
  faultDetect: {
    icon: <IconCheckProduct />,
    title: 'การตรวจจับข้อบกพร่องของสินค้า',
    className: 'Products__grid-2',
    body: 'ระบบ AI ที่นำมาใช้งานในกลุ่มสายการผลิตนั้น จะเน้นในเรื่องของการประกันคุณภาพสินค้าแบบเรียลไทม์ โดยเฉพาะในการตรวจจับข้อบกพร่องของสินค้าต่าง ๆ ผ่านระบบ AI โดยมีการใช้กล้องคอยตรวจจับระหว่างการทำงานเพื่อควบคุมคุณภาพและการผลิตให้เป็นไปอย่างราบรื่น และคอยตรวจสอบ defect อัตโนมัติตั้งแต่ต้นจนจบกระบวนการ เพื่อให้คุณสามารถใช้งานได้อย่างเต็มประสิทธิภาพมากที่สุด ซึ่งการตรวจสอบคุณภาพผลิตภัณฑ์ผ่านระบบ AI ที่ใช้สำหรับ QC สินค้านั้น จะช่วยลดต้นทุนการผลิต และปรับปรุงคุณภาพการผลิตได้อย่างต่อเนื่อง เช่น การนำระบบ AI เข้ามาใช้งานในกลุ่มอุตสาหกรรมหนักจำพวกรถยนต์ และชิ้นส่วนต่างๆ เพื่อนำมาตรวจสอบความผิดปกติของชิ้นส่วนรถยนต์ในกระบวนการขึ้นโครงชิ้นงาน หรือจะเป็นการนำ AI มาใช้ในอุตสาหกรรมการผลิตอาหาร ในขั้นตอนคัดแยกผลผลิตทางการเกษตร เป็นต้น',
  },
  maintenanceForcast: {
    icon: <IconMaintenance />,
    title: 'การคาดการณ์การซ่อมบำรุงเครื่องจักร',
    className: 'Products__grid-2',
    body: 'ในอุตสาหกรรมการผลิต เครื่องจักรถือเป็นสิ่งสำคัญที่จะทำให้ธุรกิจของคุณเดินหน้าต่อไปได้ การนำระบบ AI เข้ามาใช้ในการ Predictive Maintenance ต่ออุตสาหกรรมการผลิตจะช่วยให้ระบบการทำงานมีความสะดวกมากยิ่งขึ้น เพราะนอกจากจะมีการบันทึกข้อมูลและจัดเก็บเอาไว้อย่างเป็นระบบแล้ว AI จะทำการคาดการณ์และมีการแจ้งเตือนหากเกิดเหตุขัดข้องหรือถึงเวลาที่ควรจะต้องมีการซ่อมบำรุงเครื่องจักร เพื่อที่จะให้ระบบการทำงานนั้นคล่องตัวมากยิ่งขึ้น ลดค่าใช้จ่ายในการซ่อมแซมเครื่องจักร และเพิ่มความปลอดภัยให้กับพนักงานที่ต้องควบคุมเครื่องจักรนั้น ๆ',
  },
  safety: {
    icon: <IconSafety />,
    title: 'ความปลอดภัยในการทำงาน',
    className: 'Products__grid-2',
    body: 'เรื่องของความปลอดภัยถือเป็นสิ่งสำคัญอย่างมากต่อการทำงาน โดยเฉพาะในอุตสาหกรรมการผลิตที่มีการใช้เครื่องจักรอยู่เป็นประจำ การนำเทคโนโลยีระบบ AI เข้ามา จะช่วยเพิ่มความปลอดภัยระหว่างการทำงานได้เป็นอย่างดี เพราะเทคโนโลยี AI ในกลุ่มสายการผลิตนั้น ยังจะสามารถนำไปใช้ตรวจจับใบหน้าและเครื่องแต่งกายของพนักงานภายในโรงงาน ซึ่ง AI จะสามารถทำการตรวจสอบเครื่องแต่งกายของพนักงานรายคนได้เลยว่ามีใครบ้างที่ไม่สวมใส่อุปกรณ์ป้องกันบ้าง จากนั้นจะทำการแจ้งเตือนไปยังพนักงานคนนั้น ๆ บนระบบ เพื่อให้สอดคล้องกับมาตรฐานและนโยบายความปลอดภัยของบริษัท อีกทั้งยังจะช่วยลดแรงงานคนในการนั่งมอนิเตอร์เพื่อตรวจสอบในอุตสาหกรรมการผลิต ช่วยลดการเกิดอุบัติเหตุระหว่างการทำงานได้อย่างมีประสิทธิภาพ',
  },
}

const logisticDataset = {
  inventory: {
    icon: <IconCollect />,
    title: 'พัฒนาการจัดเก็บและวางแผนพื้นที่สำหรับการเก็บสินค้า',
    className: 'Products__grid-2',
    body: 'AI กับอุตสาหกรรมโลจิสติกส์ถือเป็นสิ่งคู่กันมาอย่างเนิ่นนาน ไม่ว่าจะเป็นการนำ AI มาใช้ในการวางแผนเพื่อพื้นที่จัดเก็บสินค้า ไปจนถึงการนำเทคโนโลยี AI เข้ามาใช้ในการคัดแยกสินค้า จัดเรียงพาเลทสำหรับเก็บ ไปจนถึงการใช้ระบบตรวจสอบแพ็กเกจอัตโนมัติที่จะเข้ามาช่วยตรวจสอบว่าสินค้าประเภทต่าง ๆ มีการแพคอย่างดีหรือไม่ หรือควรนำมาจัดเก็บใหม่ เพื่อป้องกันไม่ให้สินค้าเสียหาย อีกทั้งยังเพิ่มประสิทธิภาพในการจัดการคลังสินค้า และช่วยทำให้เห็นภาพรวมของสินค้าคงคลังได้อีกด้วย',
  },
  forcasting: {
    icon: <IconAnalyse />,
    title: 'วิเคราะห์ความต้องการล่วงหน้า',
    className: 'Products__grid-2',
    body: 'การวิเคราะห์แนวโน้มและภาพรวมของการขนส่งถือเป็นความสามารถสำคัญของ AI ในอุตสาหกรรมโลจิสติกส์ เพื่อช่วยทำนายหรือคาดคะเนล่วงหน้า ทั้งเรื่องของสินค้าและคาดการณ์วิเคราะห์เกี่ยวกับแนวโน้มของลูกค้าในอนาคตได้อย่างมีประสิทธิภาพ เพื่อให้สามารถวางแผนและเตรียมความพร้อมได้อย่างดี อีกทั้งยังรวมไปถึงการคาดการณ์ล่วงหน้าเกี่ยวกับความเสียหายของอุปกรณ์ต่าง ๆ ซึ่งจะช่วยป้องกันไม่ให้เกิดความเสียหายและประหยัดค่าใช้จ่ายได้',
  },
  planing: {
    icon: <IconLogistic />,
    title: 'วางกลยุทธ์การทำงานด้านโลจิสติกส์',
    className: 'Products__grid-2',
    body: 'AI คือตัวช่วยในการเข้ามาตรวจสอบและเรียนรู้เกี่ยวกับขั้นตอนการดำเนินการต่าง ๆ ภายในคลังสินค้า ไม่ว่าจะเป็นการตรวจสอบสินค้า การเลือกใช้ยานพาหนะ เส้นทางการขนส่ง ไปจนถึงการดูแลพาหนะและสินทรัพย์อื่น ๆ เพื่อช่วยสร้างความเข้าใจให้มากยิ่งขึ้นและช่วยกำหนดกลยุทธ์ที่มีความแม่นยำ เพื่อเพิ่มประสิทธิภาพให้กับธุรกิจ ซึ่งการตรวจสอบสินค้าโดยใช้ AI จะช่วยให้คุณสามารถวางแผนในการเลือกสินค้าที่ดีที่สุด อีกทั้งยังสามารถจัดการปัญหาได้อย่างตรงจุดบนพื้นฐานของความเป็นจริงตามข้อมูลที่ได้รับ',
  },
}

export default function AiInIndustries() {
  const [industryKey, setIndustryKey] = React.useState(
    Object.keys(industryDataset)[0]
  )
  const [logisticKey, setLogisticKey] = React.useState(
    Object.keys(logisticDataset)[0]
  )

  const selectedIndustryData = industryDataset[industryKey]
  const selectedLogisticData = logisticDataset[logisticKey]

  return (
    <React.Fragment>
      <Meta
        title='AI ในอุตสาหกรรม ทั้งในกลุ่มสายการผลิตและโลจิสติกส์ | Data Wow'
        description='Data Wow ให้บริการด้านวิศวกรรมข้อมูล ช่วยเพิมขีดจำกัดให้ธุรกิจคุณ ทั้งบริการ Big Data, AI Development, Web Software Development และ Data Management'
      />

      <div className='Products'>
        <div className='container'>
          <div className='Products__hero'>
            <div>
              <h1>
                AI ในอุตสาหกรรม ทั้งในกลุ่ม<span>สายการผลิต</span>และ
                <span>โลจิสติกส์</span>
              </h1>
              <p>
                AI เข้ามามี
                <strong>บทบาทต่อการทำงานทั้งในอุตสาหกรรมด้านการผลิต</strong>
                และอุตสาหกรรมด้านการขนส่งและโลจิสติกส์
                จะช่วยเพิ่มความคล่องตัวมากยิ่งขึ้นแล้วยังช่วยทุ่นแรงและทำให้เกิดความ
                <strong>ถูกต้อง แม่นยำ</strong>ต่อกระบวนการผลิต
              </p>
            </div>

            <div className='Products__img'>
              <figure className='Products__img__figure'>
                <picture>
                  <source
                    srcSet='/images/products/ai-industries.webp, /images/products/ai-industries@2x.webp 2x'
                    type='image/webp'
                  />
                  <source
                    srcSet='/images/products/ai-industries.png, /images/products/ai-industries@2x.png 2x'
                    type='image/png'
                  />
                  <img
                    src='/images/ai-industries.png'
                    srcSet='/images/ai-industries.png, /images/ai-industries@2x.png 2x'
                    alt='Logistics'
                    className='Index__face-detector__img'
                    width='465'
                    height='465'
                    loading='lazy'
                  />
                </picture>
              </figure>
            </div>
          </div>

          <div className='Products__content'>
            <div className='Products__block'>
              <h2>AI ในอุตสาหกรรม ทั้งในกลุ่มสายการผลิตและโลจิสติกส์</h2>
              <p>
                เมื่อก้าวเข้าสู่ยุคที่เทคโนโลยีเข้ามาเป็นส่วนหนึ่งในการทำงาน
                ซึ่งในปัจจุบันมีหลายบริษัทได้นำเอาเทคโนโลยี AI
                เข้ามาเป็นส่วนหนึ่งในการพัฒนาระบบการทำงานให้มีประสิทธิภาพมากยิ่งขึ้น
                ซึ่งนอกจากจะช่วยให้การทำงานเกิดความคล่องตัวมากยิ่งขึ้นแล้ว
                ยังช่วยทุ่นแรงและทำให้เกิดความถูกต้อง แม่นยำต่อกระบวนการผลิตด้วย
                โดยสายงานที่นิยมนำเอาเทคโนโลยี AI
                เข้ามาใช้มีอยู่หลากหลายอุตสาหกรรมด้วยกัน
                ทั้งอุตสาหกรรมด้านการขนส่งและโลจิสติกส์
                รวมถึงอุตสาหกรรมด้านการผลิตที่สามารถแยกย่อยได้อีกหลายหลายอุตสาหกรรม
                ไม่ว่าจะเป็นอุตสาหกรรมด้านอาหาร ด้านผลิตภัณฑ์ความงาม
                หรือการผลิตสินค้าอีกหลายๆ ประเภท
              </p>
              <p>
                เรามาดูกันว่าการนำ AI
                เข้ามามีบทบาทต่อการทำงานทั้งในอุตสาหกรรมด้านการผลิตและอุตสาหกรรมด้านการขนส่งและโลจิสติกส์
                จะช่วยเพิ่มความคล่องตัวต่อการดำเนินธุรกิจของคุณได้อย่างไรบ้าง?
              </p>
              <h3>ด้านอุตสาหกรรมการผลิต</h3>
              <div className='Products__card-grid'>
                <div className='Products__card-grid__filters'>
                  {Object.entries(industryDataset).map(
                    ([key, value], index) => (
                      <CardSelect
                        key={key}
                        icon={value.icon}
                        title={value.title}
                        isSelected={key === industryKey}
                        onClick={() => {
                          setIndustryKey(key)
                        }}
                      />
                    )
                  )}
                </div>
                <Card>
                  {selectedIndustryData && (
                    <CardItem
                      title={selectedIndustryData.title}
                      body={selectedIndustryData.body}
                    />
                  )}
                </Card>
              </div>
              <h3>ด้านอุตสาหกรรมโลจิสติกส์</h3>
              <div className='Products__card-grid'>
                <div className='Products__card-grid__filters'>
                  {Object.entries(logisticDataset).map(
                    ([key, value], index) => (
                      <CardSelect
                        key={key}
                        icon={value.icon}
                        title={value.title}
                        isSelected={key === logisticKey}
                        onClick={() => {
                          setLogisticKey(key)
                        }}
                      />
                    )
                  )}
                </div>
                <Card>
                  {selectedLogisticData && (
                    <CardItem
                      title={selectedLogisticData.title}
                      body={selectedLogisticData.body}
                    />
                  )}
                </Card>
              </div>
              <p>
                Data Wow
                เรามีทีมงานที่จะช่วยให้คุณเข้าใจถึงความสำคัญของการใช้เทคโนโลยี
                AI เพื่อนำไปปรับใช้ภายในองค์กร
                โดยทีมงานและผู้เชี่ยวชาญของเราจะช่วยออกแบบระบบ AI
                ให้เหมาะสมกับอุตสาหกรรมหรือธุรกิจของคุณ
                ที่จะช่วยพัฒนาการระบบการทำงานภายในองค์กรให้เกิดความราบรื่นและต่อเนื่องมากที่สุด
              </p>
              <p>
                หากคุณกำลังมองหาผู้พัฒนาและให้บริการ AI Software
                ในกลุ่มสายการผลิต โลจิสติกส์ หรือในอุตสาหกรรมอื่น ๆ
                เพื่อปรับใช้ในองค์กรได้อย่างเหมาะสม สามารถติดต่อกับเราได้ทันที
                ทีมงานของเรารอคุณอยู่{' '}
                <a href='mailto:sales@datawow.io'>sales@datawow.io</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

AiInIndustries.getLayout = function getLayout(page) {
  return <MainLayout>{page}</MainLayout>
}
